import type { FC, ReactElement } from 'react';

import { useHideCurrency } from '../../../store/compositeSelectors/useHideCurrency';
import { useGameStateSlice } from '../../../store/slices/game/selectors';
import type { InputProps } from '../baseInput/BaseInput';

import { CurrencyInput } from './CurrencyInput';

export interface CurrencyInputConnectedProps extends Omit<InputProps, 'prefix'> {
  initialValue?: string;
  containerClass?: string;
  errorMsg?: string;
}

export const CurrencyInputConnected: FC<CurrencyInputConnectedProps> = ({ initialValue, ...rest }): ReactElement => {
  const currencyInfo = useGameStateSlice.getCurrencyInfo();
  const hideCurrenncy = useHideCurrency();
  const currency = useGameStateSlice.getCurrency();

  const currencySymbol = currencyInfo?.symbol ?? currency ?? '';

  return (
    <CurrencyInput
      currencySymbol={hideCurrenncy ? '' : currencySymbol}
      currencyInfo={currencyInfo || undefined}
      initialValue={initialValue}
      {...rest}
    />
  );
};
